import React from 'react';
import { css } from '@emotion/react';
import { colors, fontStyles, spacing } from '../../styles';
import { Testimonial } from './constants';

interface TestimonialsCarouselProps {
  testimonials: Testimonial[];
}

export const TestimonialsCarousel: React.FC<TestimonialsCarouselProps> = ({ testimonials }) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        margin-bottom: ${spacing.deci};
      `}
    >
      {testimonials.map((testimonial, index) => (
        <div
          key={index}
          css={css`
            padding: ${spacing.deci} 0;
            ${index < testimonials.length - 1 &&
            `
              border-bottom: 1px solid ${colors.cloud};
            `}

            html[data-theme='dark'] & {
              border-color: ${colors.tungsten};
            }
          `}
        >
          {/* Quote content */}
          <div
            css={css`
              ${fontStyles.dog}
              color: ${colors.liquorice};
              line-height: 1.5;
              margin-bottom: ${spacing.centi};

              html[data-theme='dark'] & {
                color: ${colors.cloud};
              }
            `}
          >
            &ldquo;{testimonial.title}. {testimonial.content}&rdquo;
          </div>

          {/* Author and stars */}
          <div
            css={css`
              display: flex;
              align-items: center;
              gap: ${spacing.milli};
            `}
          >
            <span
              css={css`
                ${fontStyles.mouse}
                color: ${colors.tungsten};

                html[data-theme='dark'] & {
                  color: ${colors.fog};
                }
              `}
            >
              {testimonial.author}
            </span>
            <span
              css={css`
                color: #ffd700;
                font-size: 12px;
                letter-spacing: -1px;
              `}
            >
              ★★★★★
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
